import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { STR_CONTACT_US } from "../Strings";
import MobileInterface from "../MobileInterface";

import { FaTelegram, FaWhatsapp } from "react-icons/fa";
import { MdCall, MdEmail } from "react-icons/md";


export default function ContactUs(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..
    setReady(true);
  }



  useEffect(() => {
    init();
  }, [])



  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
        }}
        className="mNoScrollBar"
      >
        <div className="container">

          <div className="row">

            <div className="col-md-12">
              <div className="row" style={{ marginTop: "10px", marginBottom: "30px", }}>

                <div className="col-md-12">
                  <h6
                    style={{
                      fontSize: "28px",
                    }}
                    className="font-light"
                  >
                    {STR_CONTACT_US[appContext.language]}
                  </h6>
                </div>

                <div
                  className="col-12 mt-2 mb-2" style={{ height: "100%" }}
                >
                  <div
                    className="d-flex bg-surface mShadow3"
                    style={{
                      height: "100%",
                      padding: "10px",
                      fontSize: "12px",
                      borderRadius: "10px",
                    }}

                    onClick={() => {
                      MobileInterface.openLink('https://wa.me/255717396253')
                    }}
                  >
                    <FaWhatsapp className="align-self-center" size={40} style={{ flexShrink: "0" }} />

                    <h6
                      className="align-self-center font-semi-bold mNoMargin"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "10px",
                      }}
                    >
                      WhatsApp
                    </h6>
                  </div>
                </div>

                <div
                  className="col-12 mt-2 mb-2" style={{ height: "100%" }}
                >
                  <div
                    className="d-flex bg-surface mShadow3"
                    style={{
                      height: "100%",
                      padding: "10px",
                      fontSize: "12px",
                      borderRadius: "10px",
                    }}

                    onClick={() => {
                      MobileInterface.openLink('https://t.me/255717396253')
                    }}
                  >
                    <FaTelegram className="align-self-center" size={40} style={{ flexShrink: "0" }} />

                    <h6
                      className="align-self-center font-semi-bold mNoMargin"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "10px",
                      }}
                    >
                      Telegram
                    </h6>
                  </div>
                </div>

                <div
                  className="col-12 mt-2 mb-2" style={{ height: "100%" }}
                >
                  <div
                    className="d-flex bg-surface mShadow3"
                    style={{
                      height: "100%",
                      padding: "10px",
                      fontSize: "12px",
                      borderRadius: "10px",
                    }}

                    onClick={() => {
                      MobileInterface.openLink('tel:+255717396253')
                    }}
                  >
                    <MdCall className="align-self-center" size={40} style={{ flexShrink: "0" }} />

                    <h6
                      className="align-self-center font-semi-bold mNoMargin"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "10px",
                      }}
                    >
                      +255 717 396 253
                    </h6>
                  </div>
                </div>

                <div
                  className="col-12 mt-2 mb-2" style={{ height: "100%" }}
                >
                  <div
                    className="d-flex bg-surface mShadow3"
                    style={{
                      height: "100%",
                      padding: "10px",
                      fontSize: "12px",
                      borderRadius: "10px",
                    }}

                    onClick={() => {
                      MobileInterface.openLink('mailto:amakirita@gmail.com')
                    }}
                  >
                    <MdEmail className="align-self-center" size={40} style={{ flexShrink: "0" }} />

                    <h6
                      className="align-self-center font-semi-bold mNoMargin"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "10px",
                      }}
                    >
                      Email
                    </h6>
                  </div>
                </div>

              </div>
            </div>



          </div>

        </div>


      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}